import request from '@/utils/request'


// 查询排列五列表
export function listPl5(query) {
    return request({
        url: '/admin/lottery/pl5/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期排列五数据
export function latestPl5() {
    return request({
        url: '/admin/lottery/pl5/latest',
        method: 'get',
    })
}

// 初始化排列五数据
export function initAllPl5() {
    return request({
        url: '/admin/lottery/pl5/initAll',
        method: 'post'
    })
}

// 补全排列五历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/pl5/fillHistoryData',
        method: 'post'
    })
}

// 初始化排列五统计数据
export function initAllPl5C() {
    return request({
        url: '/admin/lottery/pl5/initAllC',
        method: 'post'
    })
}

// 刷新排列五缓存
export function refreshPl5Cache() {
    return request({
        url: '/admin/lottery/pl5/refreshCache',
        method: 'delete',
    })
}
// 生成排列五
export function generatePl5(data) {
    return request({
        url: '/admin/lottery/pl5/generate',
        method: 'post',
        data:data
    })
}

// 查询排列五中奖数据
export function getPl5WinningData(query){
    return request({
        url: '/admin/lottery/pl5/getWinningData',
        method: 'get',
        params: query
    })
}
// 查询排列五历史同期中奖数据
export function getNextPl5History(period){
    return request({
        url: '/admin/lottery/pl5/getNextHistory?period='+period,
        method: 'get'
    })
}

// 查询排列五下期数字频率
export function getNextNumFrequency(query){
    return request({
        url: '/admin/lottery/pl5/getNextNumFrequency',
        method: 'get',
        params: query
    })
}
